import type { FC } from "react";
import { lazy, Suspense } from "react";

import { SkeletonSignInPage } from "./SkeletonSignInPage";

const SignInPage = lazy(() => import("./SignInPageDefault"));

interface Props {
  additionalAttributes?: any;
  newSSOErrors?: string;
  authErrors?: string;
}

const LazySignInPage: FC<Props> = ({ additionalAttributes, newSSOErrors, authErrors }) => {
  const formVersion = "MainSigninPage";

  return (
    <Suspense fallback={<SkeletonSignInPage />}>
      <SignInPage
        newSSOErrors={newSSOErrors}
        authErrors={authErrors}
        additionalAttributes={{ formVersion, ...additionalAttributes }}
      />
    </Suspense>
  );
};

export { LazySignInPage };
